import { motion } from 'framer-motion';
import { Mail } from 'lucide-react';
import { ButtonLink } from '@/components/ui/button-link';
import { PUBLIC_ROUTES } from '@/constants';
import { fadeUp } from './portalAnimations';

function PublicNewsletterCta({ className }) {
  return (
    <motion.section
      variants={fadeUp}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
      className={`relative overflow-hidden rounded-2xl border border-primary/20 bg-gradient-to-br from-primary-900 via-primary-800 to-primary-700 p-8 text-white shadow-xl sm:p-12 ${className || ''}`}
      aria-labelledby="newsletter-cta-heading"
    >
      <div className="vp-hero-mesh absolute inset-0 opacity-60" aria-hidden="true" />
      <div className="relative mx-auto max-w-2xl text-center">
        <Mail className="mx-auto h-10 w-10 text-accent-cyan" aria-hidden="true" />
        <h2 id="newsletter-cta-heading" className="mt-4 font-display text-2xl font-bold sm:text-3xl">
          Never miss a rally
        </h2>
        <p className="mt-3 text-sm text-white/75 sm:text-base">
          Get tournament updates, live match alerts, and registration deadlines. Contact us to join the VolleyPro
          community mailing list.
        </p>
        <div className="mt-6 flex flex-wrap justify-center gap-3">
          <ButtonLink variant="accent" size="lg" to={PUBLIC_ROUTES.CONTACT}>
            Subscribe via Contact
          </ButtonLink>
          <ButtonLink
            variant="outline"
            size="lg"
            to={PUBLIC_ROUTES.LIVE}
            className="border-white/25 bg-white/5 text-white hover:bg-white/10 hover:text-white"
          >
            Watch Live Now
          </ButtonLink>
        </div>
      </div>
    </motion.section>
  );
}

export default PublicNewsletterCta;
